export const POLITICAL_PREFIX = [
	'Techno-',
	'Crypto-',
	'Anarcho-',
	'Geo-',
	'Eco-',
	'Moderate ',
	'Radical ',
	'Progressive ',
	'Regressive ',
	'Constitutional ',
	'Revolutionary ',
	'Agrarian ',
	'Socio-',
	'Neo-',
	'Popular ',
	'United ',
	'Anti-',
	'Independent ',
	'Patriotic ',
	'Colonial ',
	'Xeno-',
	'Deutero-',
	'Pan-',
	'Post-',
	'Alt-',
	'Counter-',
	'Ethno-',
	'Ergato-',
	'Partheno-',
	'Sub-',
	'Fundibular ',
	'Ecclesiastic ',
	'Right And Proper ',
	'Pseudo-',
	'Paleo-',
	'Provisionary ',
	'Dispensational ',
	'Feudal ',
	'Tribal ',
	'Directorial ',
	'Free ',
	'Semi-',
	'Demi-',
	'Regional ',
	'Syncretic ',
	'Agnatic ',
	'Cognatic ',
	'Enatic ',
	'Elective ',
	'Bourgeois ',
	'Proletarian ',
	'Deliberative ',
	'Geriatric ',
	'International ',
	'Green ',
	'Orange ',
	'Red ',
	'Yellow ',
	'Golden ',
	'Vegan ',
	'Trans-',
	'Hegelian ',
	'Ultra-',
	'Syndic ',
	'Tripartite ',
	'Cosmopolitan ',
	'Collaborative ',
	'Open ',
	'Heroic ',
	'Para-',
	'Proto',
	'Clerical ',
	'Analytical ',
	'Mythopoetic ',
	'Fiscal ',
	'Integral ',
	'Alter-',
	'Gestalt ',
	'Global ',
	'Omni-'
];

export const POLITICAL_PARTY_NAME = [
	'Socialist',
	'Democratic',
	'Republican',
	'Monarchist',
	'Communist',
	'Fascist',
	'Libertarian',
	'Unionist',
	'Particularist',
	'Nationalist',
	'Separatist',
	'Centrist',
	'Imperialist',
	'Populist',
	'Traditionalist',
	'Spartacist',
	'Confederate',
	'Federalist',
	'Survivalist',
	'Dominionist',
	'Heritagist',
	'Marxist',
	'Trotskyist',
	'Immortalist',
	'Bolshevist',
	'Menshevist',
	'Pacifist',
	'Loyalist',
	'Legislaturist',
	'Rationalist',
	'Originalist',
	'Reformist',
	'Nativist',
	'Expansionist',
	'Abolitionist',
	'Capitalist',
	'Corporatist',
	'Materialist',
	'Egoist',
	'Absolutist',
	'Consumerist',
	'Situationist',
	'Dogmatist',
	'Libertine',
	'Isolationist',
	'Accelerationist',
	'Statist',
	'Extremist',
	'Hegemonic',
	'Demarchist',
	'Parliamentarian',
	'Geniocratic',
	'Timocratic',
	'Platformist',
	'Primitivist',
	'Specifist',
	'Humanist',
	'Leninist',
	'Vanguardist',
	'Authoritarian',
	'Irridentist',
	'Optimate',
	'Legitimist',
	'Promethian',
	'Gaian',
	'Luddite',
	'Feminist',
	'Agonist',
	'Ochlocratic',
	'Reconstructionist',
	'Revivalist',
	'Abstentionist',
	'Punk',
	'Extropian'
];